import 'react-phone-input-2/lib/material.css';

import { FormHelperText, TextFieldProps } from '@mui/material';
import PropTypes from 'prop-types';
import { FC, useState } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-input-2';
import es from 'react-phone-input-2/lang/es.json';

import { COUNTRY_PHONE_DEFAULT } from '../../../constants/constants';
import useStyles from './styles';

type PhoneInputProps = TextFieldProps & {
  // eslint-disable-next-line
  name: any;
  control: any;
  i18nLabelKey: any;
  required: any;
  disabled?: boolean;
  variant?: 'outlined' | 'standard' | 'filled';
};

const CustomPhoneInput: FC<PhoneInputProps> = ({
  name,
  control,
  i18nLabelKey,
  required,
  disabled,
}) => {
  const [countryCode, setCountryCode] = useState(0);
  const classes = useStyles();
  const { t } = useTranslation();

  const isValidValueSize = (value: string, countryCode: number): boolean => {
    if (value.length < 1) {
      return true;
    }

    switch (countryCode) {
      case 54:
      case 56:
        return !(value.length < 11 || value.length > 15);
      case 58:
        return !(value.length !== 12);
      case 57:
      case 52:
        return !(value.length < 12 || value.length > 15);
      default:
        return !(value.length < 11 || value.length > 20);
    }
  };

  const getLabel = () => {
    return t(i18nLabelKey);
  };

  const rules = {
    required: required && `${getLabel() || name} es requerido`,
    validate: (value: string) => {
      if (!isValidValueSize(value, countryCode)) {
        return 'Teléfono inválido';
      }
    },
  };

  return (
    <>
      <Controller
        control={control}
        name={name}
        defaultValue={''}
        render={({ field, fieldState: { error } }) => (
          <>
            <PhoneInput
              {...field}
              specialLabel={getLabel()}
              inputProps={{
                name: i18nLabelKey,
                id: i18nLabelKey,
                required,
              }}
              localization={es}
              disabled={disabled}
              inputStyle={{
                borderColor: error && 'red',
              }}
              containerClass={classes.borderInput}
              containerStyle={{
                color: error && 'red',
              }}
              dropdownStyle={{
                color: 'black',
              }}
              onChange={(value, country: any) => {
                field.onChange(value);
                setCountryCode(country.countryCode);
              }}
              isValid={() => true}
              enableLongNumbers
              country={COUNTRY_PHONE_DEFAULT}
            />
            {error && (
              <FormHelperText error style={{ marginLeft: '14px' }}>
                {error.message}
              </FormHelperText>
            )}
          </>
        )}
        rules={rules}
      />
    </>
  );
};

CustomPhoneInput.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  i18nLabelKey: PropTypes.string.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

CustomPhoneInput.displayName = 'CustomPhoneInput';

export default CustomPhoneInput;
